import { Reducer } from "@reduxjs/toolkit";
import { GrupoState, GrupoTypes } from "./types";

const INITIAL_STATE: GrupoState = {
    data: {
        table: null,
        grupo: null
    },
    error: false,
    errorMessage: null,
    loading: false,
    loadingTable: false,
    loadingPersis: false,
    loadingInativacao: false,
};

const reducer: Reducer<GrupoState> = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GrupoTypes.GRUPO_TABLE_REQUEST:
            return {
                ...state,
                error: false,
                loadingTable: true,
            };
        case GrupoTypes.GRUPO_TABLE_REQUEST_SUCCESS:
            return {
                ...state,
                error: false,
                loadingTable: false,
                data: {
                    ...state.data,
                    table: action.payload.data
                }
            };
        case GrupoTypes.GRUPO_TABLE_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loadingTable: false,
                errorMessage: action.payload.err,
                data: {
                    ...state.data,
                    table: null
                }
            };


        case GrupoTypes.GRUPO_INATIVA_REQUEST:
            return {
                ...state,
                error: false,
                loading: true,
                loadingInativacao: true,
            };
        case GrupoTypes.GRUPO_INATIVA_REQUEST_SUCCESS:
            alert('Ação realizada com sucesso!');
            return {
                ...state,
                error: false,
                loading: false,
                loadingInativacao: false,
            };
        case GrupoTypes.GRUPO_INATIVA_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loading: false,
                loadingInativacao: false,
                errorMessage: action.payload.err,
            };



        case GrupoTypes.GRUPO_DATA_REQUEST:
            return {
                ...state,
                error: false,
                loading: true,
            };
        case GrupoTypes.GRUPO_DATA_REQUEST_SUCCESS:
            return {
                ...state,
                error: false,
                loading: false,
                data: {
                    ...state.data,
                    grupo: action.payload.data
                }
            };
        case GrupoTypes.GRUPO_DATA_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loading: false,
                errorMessage: action.payload.err,
                data: {
                    ...state.data,
                    grupo: null
                }
            };


        case GrupoTypes.CLEAR_GRUPO_DATA:
            return {
                ...state,
                error: false,
                loading: false,
                data: {
                    ...state.data,
                    grupo: null
                }
            };

        case GrupoTypes.GRUPO_SAVE_REQUEST:
            return {
                ...state,
                error: false,
                loadingPersis: true,
            };
        case GrupoTypes.GRUPO_SAVE_REQUEST_SUCCESS:
            alert('Cadastro de Grupo realizado com sucesso!');
            return {
                ...state,
                error: false,
                loadingPersis: false,
                data: {
                    ...state.data,
                    grupo: action.payload.data
                }
            };
        case GrupoTypes.GRUPO_SAVE_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loadingPersis: false,
                errorMessage: action.payload.err,
            };

        case GrupoTypes.GRUPO_UPDATE_REQUEST:
            return {
                ...state,
                error: false,
                loadingPersis: true,
            };
        case GrupoTypes.GRUPO_UPDATE_REQUEST_SUCCESS:
            alert('Edição de Grupo realizada com sucesso!');
            return {
                ...state,
                error: false,
                loadingPersis: false,
                data: {
                    ...state.data,
                    grupo: action.payload.data
                }
            };
        case GrupoTypes.GRUPO_UPDATE_REQUEST_FAILURE:
            return {
                ...state,
                error: true,
                loadingPersis: false,
                errorMessage: action.payload.err,
            };


        default:
            return {
                ...state,
                error: false,
                loading: false,
                errorMessage: null
            };
    }
};

export default reducer;